import { Check, Video } from 'lucide-react';
import styles from './ChecklistItem.module.css';

interface ChecklistItemProps {
  task: string;
  completed: boolean;
  type?: 'task' | 'video';
  onToggle: () => void;
}

export function ChecklistItem({ task, completed, type = 'task', onToggle }: ChecklistItemProps) {
  const isVideo = type === 'video';

  return (
    <button className={styles.container} onClick={onToggle}>
      {isVideo ? (
        <div className={`${styles.videoIcon} ${completed ? styles.videoIconCompleted : ''}`}>
          {completed ? (
            <Check size={14} strokeWidth={3} />
          ) : (
            <Video size={16} strokeWidth={2} />
          )}
        </div>
      ) : (
        <div className={`${styles.checkbox} ${completed ? styles.checkboxCompleted : ''}`}>
          {completed && <Check size={14} strokeWidth={3} />}
        </div>
      )}
      <span className={`${styles.task} ${completed ? styles.taskCompleted : ''}`}>
        {task}
      </span>
    </button>
  );
}


